<template>
  <section id="blog" class="blog-wrap bg-albastor pt-100 pb-75">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <div class="section-title style1 text-center mb-40">
            <span>Blog &amp; News</span>
            <h2>Read Our Latest News & Articles</h2>
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div
          class="col-xl-4 col-lg-6 col-md-6"
          v-for="blog in blogs"
          :key="blog.id"
        >
          <div class="blog-card style4">
            <div class="blog-img">
              <img :src="blog.image" alt="Image" />

              <a href="#" class="blog-cat">{{ blog.tag }}</a>
            </div>
            <div class="blog-info">
              <span class="blog-date"> {{ blog.date }} </span>
              <ul class="blog-metainfo list-style">
                <li>
                  <i class="ri-user-add-line"></i>
                  <a href="#">{{ blog.user }}</a>
                </li>
                <li>
                  <i class="ri-chat-4-line"></i>
                  <router-link to="/blog-details">
                    {{ blog.comment }} Comments
                  </router-link>
                </li>
              </ul>
              <h3>
                <router-link to="/blog-details">
                  {{ blog.title }}
                </router-link>
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "LatestNews",
  data: () => ({
    blogs: [
      {
        id: 1,
        image: require("../../assets/images/blog/blog-10.jpg"),
        user: "Admin",
        date: "29 June",
        tag: "Exploration",
        comment: "0",
        title: "Whatever You Do, Make Sure It Leads You To Happy Life",
      },
      {
        id: 2,
        image: require("../../assets/images/blog/blog-11.jpg"),
        user: "Admin",
        date: "28 June",
        tag: "Treatment",
        comment: "2",
        title: "The Day I'd Spent At The Square Medical Facility Center",
      },
      {
        id: 3,
        image: require("../../assets/images/blog/blog-12.jpg"),
        user: "Admin",
        date: "27 June",
        tag: "Technology",
        comment: "7",
        title: "How Does Science Help In Dental Surgery Research",
      },
    ],
  }),
});
</script>